import React from "react";

const LoomIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4228_102297)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 7.11034H11.3214L15.3732 4.77091L14.4835 3.2293L10.4315 5.56862L12.7704 1.51705L11.2287 0.62666L8.88987 4.67824V0H7.11013V4.67875L4.77039 0.62666L3.22919 1.51663L5.56852 5.56821L1.51653 3.22919L0.62666 4.7705L4.67855 7.10982H0V8.88977H4.67813L0.62666 11.2289L1.51653 12.7706L5.568 10.4317L3.22878 14.4833L4.77029 15.3731L7.10961 11.3211V15.9999H8.88945V11.3216L11.2283 15.3731L12.7698 14.4833L10.4306 10.4313L14.4825 12.7706L15.3724 11.2289L11.3209 8.88997H15.9991V7.11044L16 7.11034ZM7.9999 10.4205C6.65794 10.4205 5.57018 9.33283 5.57018 7.99078C5.57018 6.64882 6.65794 5.56105 7.9999 5.56105C9.34185 5.56105 10.4295 6.64882 10.4295 7.99078C10.4295 9.33283 9.34185 10.4206 7.9999 10.4206V10.4205Z",
  fill: "#625DF5"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4228_102297"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(LoomIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;